import { h, Component, Host, Element, Prop } from "@stencil/core";
import pfx from "../../../../utils/style-class-prefix-helper";
import { NavigationColumnAlignment, NavigationColumnVisibleOn } from "./constants/navigation-column-types";

/**
 * @slot [unnamed] - holds any number of HTML elements.
 */
@Component({
  tag: "eon-ui-navigation-column",
  styleUrl: "navigation-column.scss",
  shadow: true
})
export class NavigationColumn {
  @Element() hostElement: HTMLEonUiNavigationColumnElement;

  /**
   * Set to align content in meta navigation to left, center or right.
   */
  @Prop() contentAlignment: NavigationColumnAlignment;

  /**
   * Set to align content in meta navigation to left, center or right (mobile).
   */
  @Prop() contentAlignmentMobile: NavigationColumnAlignment;

  /**
   * Set to make this the dominant column in flex box layout so that it takes most of the space.
   */
  @Prop() grow: boolean;

  /**
   * Set to make this the dominant column in flex box layout so that it takes most of the space (mobile):
   */
  @Prop() growMobile: boolean;

  /**
   * Defines whether column is visible on mobile or tablet. Default is always.
   */
  @Prop() visibleOn: NavigationColumnVisibleOn;

  render() {
    return (
      <Host
        //style={{ "flex-grow": `${!!this.grow && "1"}` }}
        class={pfx({
          ["grow"]: !!this.grow,
          ["grow-mobile"]: !!this.growMobile,
          [`visible-on-${this.visibleOn}`]: !!this.visibleOn
        })}
      >
        <div
          class={pfx({
            "column-wrapper": true,
            [`alignment-${this.contentAlignment}`]: !!this.contentAlignment,
            [`alignment-mobile-${this.contentAlignmentMobile}`]: !!this.contentAlignmentMobile
          })}
        >
          <slot />
        </div>
      </Host>
    );
  }
}
